// STUDIO-BLUETOOTH-PRODUCT-CONTROL-1 · useLiveOperations.gotoRelative 의 대상 선택 로직(동작 동일) · 리모컨 레이어와 공용.
// 품절 skip · 활성 없으면 첫 판매가능 상품 · 끝이면 null.
export const pickRelative = (items, currentPid, delta) => {
  if (!Array.isArray(items) || items.length === 0) return null;
  const avail = (it) => (it.sale_status || '판매 중') !== '품절';
  const idx = items.findIndex((it) => it.product_id === currentPid);
  if (idx < 0) return (items.find(avail) || items[0]).product_id;
  for (let i = idx + delta; i >= 0 && i < items.length; i += delta) {
    if (avail(items[i])) return items[i].product_id;
  }
  return null;
};
